/* istanbul ignore file */

import { sendGAEvent } from '@noths/polaris-client-google-analytics';

const EVENT_CATEGORY = 'Navigation - mobile menu';

export const setNavOpen = (open: boolean) =>
  sendGAEvent({
    event: 'custom_event',
    event_action: open ? 'Open' : 'Close',
    event_category: EVENT_CATEGORY,
    event_label: 'not set',
  });
